import { useState } from "react";
import { Button, Input } from "@heroui/react";
import DefaultLayout from "@/layouts/default";
import { useSecuredApi } from "@/authentication";
import { getApiBase } from "@/lib/api-base";

export default function StripeSettingsPage() {
  const { postJson } = useSecuredApi();
  const [secret, setSecret] = useState("");
  const [webhook, setWebhook] = useState("");
  const [status, setStatus] = useState("");
  const save = async () => {
    setStatus("Saving...");
    try {
      await postJson(`${getApiBase()}/v1/setup/stripe`, { stripe_secret_key: secret, stripe_webhook_secret: webhook || undefined });
      setSecret(""); setWebhook(""); setStatus("Stripe connected");
    } catch (e) { setStatus(e instanceof Error ? e.message : "Save failed"); }
  };
  return <DefaultLayout><section className="mx-auto w-full max-w-xl space-y-5 p-8"><h1 className="text-2xl font-semibold">Stripe settings</h1><Input placeholder="Stripe secret key (sk_live_...)" type="password" value={secret} onChange={e => setSecret(e.target.value)} /><Input placeholder="Webhook signing secret (optional)" type="password" value={webhook} onChange={e => setWebhook(e.target.value)} /><Button onPress={save} isDisabled={!secret}>Save</Button>{status && <p>{status}</p>}</section></DefaultLayout>;
}
